<template>
  <div class="px-4 py-1 text-center text-sm text-slate-500">
    No results found. Try refining your search term or check your spelling.
  </div>
</template>
